import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "reactstrap";
import SignInWithMobile from "../../components/signInWithMobile";
import { authSSO } from "../../api/auth_sso";
import { authOTP } from "../../api/auth_otp";
import VerifyCode from "../../components/verifycode";
import SignInWithEmail from "../../components/signInWithEmail";
import SignInWithGoogle from "../../components/signInWithGoogle";
import { toEnglishDigits } from "../../modules/helper";
import useSearchParams from "./../../hooks/useSearchParams";
function Login() {
  const [searchParams, setSearchParams] = useSearchParams();
  const ssoRequestInFlight = useRef(false);

  let sso = decodeURIComponent(searchParams.get("sso"));
  let sig = searchParams.get("sig");

  const [state, setState] = useState({
    step: 1,
    loading: false,
    phone: "",
    email: "",
    remaining_sec: 0,
    componentName: "phone",
    disabled: true,
    codeError: "",
  });

  function goStepOne() {
    // here codeError will erease the codeError for verifyOTP component
    if (state.componentName === "phone") {
      setState((prev) => ({ ...prev, step: 1, codeError: "" }));
    } else if (state.componentName === "email") {
      setState((prev) => ({ ...prev, step: 3, codeError: "" }));
    }
  }

  function handleSendOTPCode(code) {
    const normalizedCode = toEnglishDigits(code).replace(/\D/g, "");
    if (normalizedCode.length !== 4 || ssoRequestInFlight.current) return;

    ssoRequestInFlight.current = true;
    setState((prev) => ({ ...prev, loading: true }));

    authSSO({
      uid: state.componentName === "phone" ? state.phone : state.email,
      otp: normalizedCode,
      fcm_token: "",
      sms_token: "",
      huawei_token: "",
      sso,
      sig,
      sso_token: "",
      google_token: "",
    })
      .then((res) => {
        // console.log(res);
        localStorage.setItem("sso_token", res.data.token);
        return res;
      })
      .then(function (res) {
        window.location.href = res.data.forum_url;
      })
      .catch((err) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          codeError: "error",
        }));
        console.log(err);
      })
      .finally(() => {
        ssoRequestInFlight.current = false;
      });
  }

  function sendOTP(data, typeOfLogin) {
    setState((prev) => ({
      ...prev,
      loading: true,
      codeError: "",
    }));
    if (typeOfLogin === "phone") {
      authOTP({ uid: data })
        .then((res) => {
          // console.log(res);
          setState((prev) => ({
            ...prev,
            phone: data,
            loading: false,
            step: 2,
            componentName: typeOfLogin,
            remaining_sec: res.data.remaining_seconds,
          }));
        })
        .catch((err) => {
          setState((prev) => ({
            ...prev,
            loading: false,
          }));
          console.log(err);
        });
    } else {
      authOTP({ uid: data })
        .then((res) => {
          // console.log(res);
          setState((prev) => ({
            ...prev,
            email: data,
            loading: false,
            step: 2,
            componentName: typeOfLogin,
            remaining_sec: res.data.remaining_seconds,
          }));
        })
        .catch((err) => {
          setState((prev) => ({
            ...prev,
            loading: false,
          }));
          console.log(err);
        });
    }
  }

  function goToEmailComponent() {
    setState((prev) => ({
      ...prev,
      step: 3,
    }));
  }

  function backButton() {
    setState((prev) => ({ ...prev, step: 1 }));
  }

  function signInWithGoogle(response) {
    setState((prev) => ({ ...prev, loading: true }));

    // console.log(response);
    authSSO({
      uid: "",
      otp: "",
      fcm_token: "",
      sms_token: "",
      huawei_token: "",
      sso,
      sig,
      sso_token: "",
      google_token: response.credential,
    })
      .then((res) => {
        localStorage.setItem("sso_token", res.data.token);
        // console.log(res);
        return res;
      })
      .then((res) => (window.location.href = res.data.forum_url))
      .catch((err) => setState((prev) => ({ ...prev, loading: false })));
  }

  return (
    <>
      {state.loading && (
        <div className="spinner-wrapper">
          <Spinner color="primary" type="grow" />
          <Spinner color="primary" type="grow" />
          <Spinner color="primary" type="grow" />
        </div>
      )}
      {state.step === 1 && (
        <>
          <div className="logo-and-welcome-holder">
            <div className="logo" />
            <div className="welcome-title">به تالار زبانشناس</div>
            <div className="welcome-title">خوش آمدید</div>
          </div>
          <div className="mobile-login-text">ورود با شماره همراه</div>
          <SignInWithMobile sendOTP={sendOTP} phone={state.phone} />

          <div className="login-with-email-parent">
            <Button
              className=""
              block
              color=""
              size=""
              onClick={goToEmailComponent}
            >
              <span>ورود با ایمیل</span>
              &nbsp;&nbsp;
              <span className="icon-email" />
            </Button>
          </div>
        </>
      )}
      {state.step === 3 && (
        <>
          <Button className="icon-wrapper" onClick={backButton}>
            <span className="icon-arrow_back_black" />
          </Button>
          <div className="logo-and-welcome-holder">
            <div className="welcome-title">به تالار زبانشناس</div>
            <div className="welcome-title">خوش آمدید</div>
          </div>
          <div className="mobile-login-text">ورود با ایمیل</div>
          <SignInWithEmail sendOTP={sendOTP} email={state.email} />

          <div className="seperator-line">
            <div className="thin-line" />
            <div className="or">یا</div>
            <div className="thin-line" />
          </div>

          <SignInWithGoogle googleResponse={signInWithGoogle} />
        </>
      )}
      {state.step === 2 && (
        <VerifyCode
          length={4}
          goStepOne={goStepOne}
          setCodeError={setState}
          codeError={state.codeError}
          enteredData={
            state.componentName === "phone" ? state.phone : state.email
          }
          editEmailPhone={
            state.componentName === "phone" ? "ویرایش شماره" : "ویرایش ایمیل"
          }
          onComplete={(code) => handleSendOTPCode(code)}
          remaining_time={state.remaining_sec}
          stateStep={state.step}
        />
      )}
    </>
  );
}

export default Login;

// http://localhost:3000/?sso=bm9uY2U9ODUyYzRjMWI0NDU1NGQ3N2ZjNWJiMTcxMzA0MmJjMWImcmV0dXJuX3Nzb191cmw9aHR0cHMlM0ElMkYlMkZ0ZXN0LnRhbGsuemFiYW5zaGVuYXMuY29tJTJGc2Vzc2lvbiUyRnNzb19sb2dpbg%3D%3D&sig=d9c6556b1ab32c7cd6cd9b1499c0de2a0765e7e62937d71d5a5773f2340fb5f0
